import React from "react";
import {SvgIcon, SvgIconProps} from "@mui/material";

const BullCondorSvg = (props: any) => (<svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg" >
    <path d="M1.02067 1V33" stroke="#88888866" strokeOpacity="0.4" strokeLinecap="round" strokeDasharray="5 5"/>
    <path d="M1 18.0226H33" stroke="#88888866" strokeOpacity="0.4" strokeLinecap="round" strokeDasharray="5 5"/>
    <path d="M1.28941 21.7232H14.4971L15.6642 18.0226M33 21.7232H31.3035L30.1364 18.0226" stroke="#A40C0C" strokeWidth="2"/>
    <path d="M15.6643 18.0226L20.0993 3.96045H25.7015L30.1365 18.0226" stroke="#089981" strokeWidth="2"/>
</svg>)

const BullCondor: React.FC<SvgIconProps> = React.memo((props) => (
    <SvgIcon {...props}>
        {BullCondorSvg(props)}
    </SvgIcon>
));

export default BullCondor
